import React from 'react'
import { IconType } from 'react-icons'

export const CoinsIcon: IconType = ({ className, size }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M258 21.89c-.5 0-1.2 0-1.8.12-4.6.85-10.1 5.1-13.7 14.81-3.8 9.7-4.6 23.53-1.3 38.34 3.4 14.63 10.4 27.24 18.2 34.94 7.6 7.7 14.5 9.8 19.1 9 4.8-.7 10.1-5.1 13.7-14.7 3.8-9.64 4.8-23.66 1.4-38.35-3.5-14.8-10.4-27.29-18.2-34.94-6.6-6.8-12.7-9.22-17.4-9.22zM373.4 151.4c-11 .3-24.9 3.2-38.4 8.9-15.6 6.8-27.6 15.9-34.2 24.5-6.6 8.3-7.2 14.6-5.1 18.3 2.2 3.7 8.3 7.2 20 7.7 11.7.7 27.5-2.2 43-8.8 15.5-6.7 27.7-15.9 34.3-24.3 6.6-8.3 7.1-14.8 5-18.5-2.1-3.8-8.3-7.1-20-7.5-1.6-.3-3-.3-4.6-.3zm-136.3 92.9c-6.6.1-12.6.9-18 2.3-11.8 3-18.6 8.4-20.8 14.9-2.5 6.5 0 14.3 7.8 22.7 8.2 8.2 21.7 16.1 38.5 20.5 16.7 4.4 32.8 4.3 44.8 1.1 12.1-3.1 18.9-8.6 21.1-15 2.3-6.5 0-14.2-8.1-22.7-7.9-8.2-21.4-16.1-38.2-20.4-9.5-2.5-18.8-3.5-27.1-3.4zm160.7 58.1L336 331.7c4.2.2 14.7.5 14.7.5l6.6 8.7 54.7-28.5-14.2-10zm-54.5.1l-57.4 27.2c5.5.3 18.5.5 23.7.8l49.8-23.6-16.1-4.4zm92.6 10.8l-70.5 37.4 14.5 18.7 74.5-44.6-18.5-11.5zm-278.8 9.1a40.33 40.33 0 0 0-9 1c-71.5 16.5-113.7 17.9-126.2 17.9H18v107.5s11.6-1.7 30.9-1.8c37.3 0 103 6.4 167 43.8 3.4 2.1 10.7 2.9 19.8 2.9 24.3 0 61.2-5.8 69.7-9C391 452.6 494 364.5 494 364.5l-32.5-28.4s-79.8 50.9-89.9 55.8c-91.1 44.7-164.9 16.8-164.9 16.8s119.9 3 158.4-27.3l-22.6-34s-82.8-2.3-112.3-6.2c-15.4-2-48.7-18.8-73.1-18.8z"></path>
    </svg>
  )
}

export const PercentIcon: IconType = ({ className, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      fill="currentColor"
      className={className}
      height={size}
      width={size}
      viewBox="0 0 1024 1024"
    >
      <path d="M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z" />
    </svg>
  )
}

export const TruckIcon: IconType = ({ className, size }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 640 512"
      className={className}
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"></path>
    </svg>
  )
}

export const FolderOpen: IconType = ({ className, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      className={className}
      height={size}
      width={size}
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
    >
      <path d="M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" />
    </svg>
  )
}

export const FolderClose: IconType = ({ className, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 1024 1024"
      height={size}
      width={size}
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
    >
      <path d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" />
    </svg>
  )
}

export const Currency: IconType = ({ className, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    height={size}
    width={size}
  >
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M17 16h2V4H9v2h8v10zm0 2v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3zM5.003 8L5 20h10V8H5.003zM7 16h4.5a.5.5 0 1 0 0-1h-3a2.5 2.5 0 1 1 0-5H9V9h2v1h2v2H8.5a.5.5 0 1 0 0 1h3a2.5 2.5 0 1 1 0 5H11v1H9v-1H7v-2z" />
    </g>
  </svg>
)

export const CogIcon: IconType = ({ className, size }) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={className}
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    ></path>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    ></path>
  </svg>
)

export const StorageIcon: IconType = ({ className, size }) => (
  <svg
    className={className}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 640 512"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"></path>
  </svg>
)

export const ViberIcon: IconType = ({ size, className }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    role="img"
    viewBox="0 0 24 24"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className ?? ''}
  >
    <path d="M11.398.002C9.473.028 5.331.344 3.014 2.467 1.294 4.177.693 6.698.623 9.82c-.06 3.11-.13 8.95 5.5 10.541v2.42s-.038.97.602 1.17c.79.25 1.24-.499 1.99-1.299l1.4-1.58c3.85.32 6.8-.419 7.14-.529.78-.25 5.181-.811 5.901-6.652.74-6.031-.36-9.831-2.34-11.551l-.01-.002c-.6-.55-3-2.3-8.37-2.32 0 0-.396-.025-1.038-.016zm.067 1.697c.545-.003.88.02.88.02 4.54.01 6.711 1.38 7.221 1.84 1.67 1.429 2.528 4.856 1.9 9.892-.6 4.88-4.17 5.19-4.83 5.4-.28.09-2.88.73-6.152.52 0 0-2.439 2.941-3.199 3.701-.12.13-.26.17-.35.15-.13-.03-.17-.19-.16-.41l.02-4.019c-4.771-1.32-4.491-6.302-4.441-8.902.06-2.6.55-4.732 2-6.172 1.957-1.77 5.475-2.01 7.11-2.02zm.36 2.6a.299.299 0 0 0-.3.299.3.3 0 0 0 .3.3 5.631 5.631 0 0 1 4.03 1.59c1.09 1.06 1.621 2.48 1.641 4.34a.3.3 0 0 0 .3.3v-.009a.3.3 0 0 0 .3-.3 6.451 6.451 0 0 0-1.81-4.76c-1.19-1.16-2.692-1.76-4.462-1.76zm-3.954.69a.955.955 0 0 0-.615.12h-.012c-.41.24-.788.54-1.148.94-.27.32-.421.639-.461.949a1.24 1.24 0 0 0 .05.541l.02.01a13.722 13.722 0 0 0 1.2 2.6 15.383 15.383 0 0 0 2.32 3.171l.03.04.04.03.03.03.03.03a15.603 15.603 0 0 0 3.18 2.33c1.32.72 2.122 1.06 2.602 1.2v.01c.14.04.268.06.398.06a1.84 1.84 0 0 0 1.102-.472c.39-.35.7-.738.93-1.148v-.01c.23-.43.15-.841-.18-1.121a13.632 13.632 0 0 0-2.15-1.54c-.51-.28-1.03-.11-1.24.17l-.45.569c-.23.28-.65.24-.65.24l-.012.01c-3.12-.8-3.95-3.959-3.95-3.959s-.04-.43.25-.65l.56-.45c.27-.22.46-.74.17-1.25a13.522 13.522 0 0 0-1.54-2.15.843.843 0 0 0-.504-.3zm4.473.89a.3.3 0 0 0 .002.6 3.78 3.78 0 0 1 2.65 1.15 3.5 3.5 0 0 1 .9 2.57.3.3 0 0 0 .3.299l.01.012a.3.3 0 0 0 .3-.301c.03-1.19-.34-2.19-1.07-2.99-.73-.8-1.75-1.25-3.05-1.34a.3.3 0 0 0-.042 0zm.49 1.619a.305.305 0 0 0-.018.611c.99.05 1.47.55 1.53 1.58a.3.3 0 0 0 .3.29h.01a.3.3 0 0 0 .29-.32c-.07-1.34-.8-2.091-2.1-2.161a.305.305 0 0 0-.012 0z" />
  </svg>
)

export const PercentageIcon: IconType = ({ className, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="currentColor"
    viewBox="0 0 1024 1024"
    height={size}
    width={size}
  >
    <path d="M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z" />
  </svg>
)

export const RestoreFromTrash: IconType = ({ className, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M13 3c-4.97 0-9 4.03-9 9H1l4 3.99L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z" />
  </svg>
)

export const TelegramIcon: IconType = ({ className, size }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 496 512"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"></path>
  </svg>
)

export const SmsIcon: IconType = ({ className, size }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"></path>
  </svg>
)

export const SelectAllIcon: IconType = ({ className, size }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"></path>
    <path d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm8.933 3.519-1.726-1.726-1.414 1.414 3.274 3.274 5.702-6.84-1.538-1.282z"></path>
  </svg>
)

export const CashRegisterIcon: IconType = ({ className, size }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"></path>
  </svg>
)

export const MapLocationIcon: IconType = ({ className, size }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fill="none"
      strokeWidth="2"
      d="M17.5,6.5 L23,9 L23,22 L16,19 L8,22 L1,19 L1,6 L6,8 M16,19 L16,12 M8,22 L8,12 M12,16.2727273 C12,16.2727273 6,11.5 6,7 C6,3.25 9,1 12,1 C15,1 18,3.25 18,7 C18,11.5 12,16.2727273 12,16.2727273 Z M13,7 C13,6.44766667 12.5523333,6 12,6 C11.4476667,6 11,6.44766667 11,7 C11,7.55233333 11.4476667,8 12,8 C12.5523333,8 13,7.55233333 13,7 Z"
    ></path>
  </svg>
)

export const PlataByMonoIcon: IconType = ({ size }) => (
  <svg height={size} viewBox="0 0 619 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="text-black dark:text-white"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.7347 0C11.9695 0 0 11.9391 0 26.6667V101.333C0 116.061 11.9695 128 26.7347 128H235.265C250.031 128 262 116.061 262 101.333V26.6667C262 11.9391 250.031 0 235.265 0H26.7347ZM218.143 85.1899H229.918V57.8163C229.918 52.1427 228.095 48.0483 224.448 45.5331C220.801 43.0179 216.103 41.7605 210.355 41.7605C202.629 41.7605 196.108 43.9832 190.792 48.4283L195.242 55.8859C199.075 52.552 203.432 50.8851 208.315 50.8851C211.282 50.8851 213.662 51.5285 215.455 52.8152C217.247 54.1021 218.143 55.8275 218.143 57.9917V63.6947C215.053 60.2435 210.324 58.5181 203.958 58.5181C199.816 58.5181 196.17 59.6587 193.017 61.9397C189.927 64.2211 188.381 67.6427 188.381 72.2051C188.381 76.5917 189.957 80.0427 193.11 82.5579C196.324 85.0144 199.94 86.2429 203.958 86.2429C210.201 86.2429 214.929 84.4296 218.143 80.8032V85.1899ZM218.143 75.0125C216.227 77.4691 213.075 78.6976 208.686 78.6976C206.276 78.6976 204.267 78.1419 202.66 77.0304C201.053 75.9192 200.249 74.3984 200.249 72.4683C200.249 70.4795 201.053 68.9296 202.66 67.8181C204.267 66.6483 206.276 66.0635 208.686 66.0635C213.075 66.0635 216.227 67.2917 218.143 69.7483V75.0125ZM174.949 86.24C170.807 86.24 167.655 85.2456 165.492 83.2568C163.328 81.2683 162.247 78.4021 162.247 74.6587V52.5491H154.829V42.8104H162.247V31.2291H174.114V42.8104H183.201V52.5491H174.114V71.6757C174.114 73.0211 174.485 74.1323 175.227 75.0096C175.969 75.8869 176.957 76.3259 178.194 76.3259C180.048 76.3259 181.408 75.9163 182.273 75.0973L184.777 83.52C182.613 85.3333 179.337 86.24 174.949 86.24ZM136.475 85.1899H148.249V57.8163C148.249 52.1427 146.426 48.0483 142.779 45.5331C139.132 43.0179 134.435 41.7605 128.687 41.7605C120.96 41.7605 114.439 43.9832 109.124 48.4283L113.574 55.8859C117.406 52.552 121.764 50.8851 126.647 50.8851C129.614 50.8851 131.993 51.5285 133.786 52.8152C135.578 54.1021 136.475 55.8275 136.475 57.9917V63.6947C133.384 60.2435 128.656 58.5181 122.289 58.5181C118.148 58.5181 114.501 59.6587 111.349 61.9397C108.258 64.2211 106.713 67.6427 106.713 72.2051C106.713 76.5917 108.289 80.0427 111.441 82.5579C114.655 85.0144 118.271 86.2429 122.289 86.2429C128.532 86.2429 133.26 84.4296 136.475 80.8032V85.1899ZM136.475 75.0125C134.559 77.4691 131.406 78.6976 127.018 78.6976C124.607 78.6976 122.598 78.1419 120.991 77.0304C119.384 75.9192 118.58 74.3984 118.58 72.4683C118.58 70.4795 119.384 68.9296 120.991 67.8181C122.598 66.6483 124.607 66.0635 127.018 66.0635C131.406 66.0635 134.559 67.2917 136.475 69.7483V75.0125ZM97.9091 85.1869H86.1341V26.6667H97.9091V85.1869ZM43.8567 79.7509C47.4415 84.0792 52.0466 86.2435 57.6713 86.2435C63.5433 86.2435 68.3026 84.2547 71.9495 80.2773C75.6581 76.3 77.5124 70.8603 77.5124 63.9584C77.5124 57.0563 75.6581 51.6459 71.9495 47.7272C68.3026 43.7496 63.5433 41.7611 57.6713 41.7611C51.9848 41.7611 47.3798 43.896 43.8567 48.1659V42.8139H32.0816V101.334H43.8567V79.7509ZM62.1215 72.9075C60.0819 75.1885 57.3622 76.3291 53.9626 76.3291C52.1083 76.3291 50.1922 75.8613 48.2141 74.9253C46.2981 73.9896 44.8456 72.8491 43.8567 71.5037V56.5008C44.8456 55.1555 46.2981 54.0149 48.2141 53.0789C50.1302 52.1432 52.0466 51.6752 53.9626 51.6752C57.3622 51.6752 60.0819 52.8157 62.1215 55.0971C64.2231 57.3781 65.2741 60.332 65.2741 63.9584C65.2741 67.6432 64.2231 70.6264 62.1215 72.9075Z"
      fill="currentColor"
    />
    <path
      className="text-black dark:text-white"
      d="M610.396 83.9618C606.376 88.1349 601.032 90.2214 594.369 90.2214C587.707 90.2214 582.366 88.1349 578.343 83.9618C574.382 79.7314 572.399 74.558 572.399 68.4414C572.399 62.3245 574.382 57.1797 578.343 53.0067C582.366 48.8336 587.707 46.7471 594.369 46.7471C601.032 46.7471 606.376 48.8336 610.396 53.0067C614.415 57.1797 616.427 62.3245 616.427 68.4414C616.427 74.558 614.415 79.7314 610.396 83.9618ZM586.615 77.1018C588.51 79.3886 591.095 80.5319 594.369 80.5319C597.644 80.5319 600.229 79.3886 602.124 77.1018C604.077 74.7581 605.054 71.8713 605.054 68.4414C605.054 65.0686 604.077 62.2389 602.124 59.9523C600.229 57.6084 597.644 56.4365 594.369 56.4365C591.095 56.4365 588.51 57.6084 586.615 59.9523C584.72 62.2389 583.772 65.0686 583.772 68.4414C583.772 71.8713 584.72 74.7581 586.615 77.1018Z"
      fill="currentColor"
    />
    <path
      className="text-black dark:text-white"
      d="M564.207 89.1925H553.263V64.1539C553.263 59.0091 550.707 56.4365 545.596 56.4365C541.632 56.4365 538.474 58.0659 536.119 61.3242V89.1925H525.175V47.7759H536.119V53.1782C539.737 48.8907 544.592 46.7471 550.678 46.7471C555.161 46.7471 558.52 47.9189 560.761 50.2626C563.057 52.6065 564.207 55.8364 564.207 59.9523V89.1925Z"
      fill="currentColor"
    />
    <path
      className="text-black dark:text-white"
      d="M511.025 83.9618C507.003 88.1349 501.662 90.2214 494.999 90.2214C488.336 90.2214 482.993 88.1349 478.973 83.9618C475.009 79.7314 473.026 74.558 473.026 68.4414C473.026 62.3245 475.009 57.1797 478.973 53.0067C482.993 48.8336 488.336 46.7471 494.999 46.7471C501.662 46.7471 507.003 48.8336 511.025 53.0067C515.045 57.1797 517.056 62.3245 517.056 68.4414C517.056 74.558 515.045 79.7314 511.025 83.9618ZM487.245 77.1018C489.14 79.3886 491.724 80.5319 494.999 80.5319C498.273 80.5319 500.858 79.3886 502.753 77.1018C504.706 74.7581 505.681 71.8713 505.681 68.4414C505.681 65.0686 504.706 62.2389 502.753 59.9523C500.858 57.6084 498.273 56.4365 494.999 56.4365C491.724 56.4365 489.14 57.6084 487.245 59.9523C485.347 62.2389 484.401 65.0686 484.401 68.4414C484.401 71.8713 485.347 74.7581 487.245 77.1018Z"
      fill="currentColor"
    />
    <path
      className="text-black dark:text-white"
      d="M464.968 89.1925H453.94V63.0392C453.94 58.6375 451.87 56.4365 447.737 56.4365C445.956 56.4365 444.288 56.9226 442.739 57.8943C441.246 58.8661 440.038 59.9809 439.119 61.2386V89.1925H428.09V63.0392C428.09 58.6375 426.023 56.4365 421.887 56.4365C420.164 56.4365 418.528 56.9226 416.977 57.8943C415.425 58.8661 414.191 60.0094 413.271 61.3242V89.1925H402.33V47.7759H413.271V53.1782C414.305 51.6918 416.115 50.2626 418.7 48.8907C421.285 47.4617 424.012 46.7471 426.885 46.7471C432.916 46.7471 436.764 49.2623 438.431 54.2929C439.753 52.2349 441.703 50.4627 444.291 48.9766C446.931 47.4902 449.745 46.7471 452.732 46.7471C456.638 46.7471 459.653 47.8045 461.781 49.9198C463.906 51.9775 464.968 55.0932 464.968 59.2662V89.1925Z"
      fill="currentColor"
    />
    <path
      className="text-black dark:text-white"
      d="M343.02 105.399L344.656 95.6241C345.692 96.0813 346.839 96.3099 348.105 96.3099C351.033 96.3099 352.957 95.3096 353.877 93.3087L355.428 89.7931L338.54 47.7764H350.258L361.113 76.5879L371.969 47.7764H383.772L364.215 95.9668C362.78 99.6256 360.769 102.169 358.184 103.599C355.6 105.085 352.354 105.885 348.448 106C346.437 106 344.629 105.8 343.02 105.399Z"
      fill="currentColor"
    />
    <path
      className="text-black dark:text-white"
      d="M304.941 75.903C305.861 77.2178 307.212 78.3325 308.993 79.2472C310.771 80.1048 312.553 80.5335 314.334 80.5335C317.492 80.5335 320.048 79.4473 322.001 77.2751C323.954 75.0456 324.932 72.1303 324.932 68.5286C324.932 64.9272 323.954 62.0119 322.001 59.7824C320.048 57.5529 317.492 56.4381 314.334 56.4381C312.553 56.4381 310.771 56.8956 308.993 57.8103C307.212 58.725 305.861 59.8683 304.941 61.2402V75.903ZM304.941 89.1941H294V32H304.941V53.0941C308.216 48.8637 312.495 46.7487 317.78 46.7487C323.18 46.7487 327.601 48.721 331.047 52.6652C334.496 56.6097 336.219 61.8975 336.219 68.5286C336.219 75.2742 334.496 80.5906 331.047 84.478C327.601 88.308 323.18 90.223 317.78 90.223C312.611 90.223 308.332 88.1079 304.941 83.8778V89.1941Z"
      fill="currentColor"
    />
  </svg>
)

export const LiqPayIcon: IconType = ({ size }) => (
  <svg height={size} viewBox="0 0 500 104" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="logo_liqpay">
      <g id="Group 2">
        <g id="Group">
          <path
            id="Path"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M420.99 80.3606L419.842 79.3766C417.054 76.9986 416.562 72.6526 419.104 69.8646L448.953 35.7524C451.331 32.9644 455.677 32.4724 458.465 35.0144L459.613 35.9984C462.401 38.3764 462.893 42.7224 460.351 45.5104L430.503 79.6226C428.125 82.4106 423.942 82.7386 420.99 80.3606Z"
            fill="url(#paint0_linear)"
          />
          <path
            id="Path_2"
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M444.934 41.6564L444.36 41.0004L439.768 46.2484L440.26 46.8224C448.133 54.6944 444.77 62.6485 442.966 65.4365L443.622 64.6985C444.688 63.4685 446.328 61.5825 448.051 59.5325C449.855 56.4164 452.397 49.0364 444.934 41.6564Z"
            fill="url(#paint1_linear)"
          />
          <path
            id="Path_3"
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M454.775 51.9064L456.005 50.5124C456.087 50.3484 456.251 50.1844 456.333 50.0204C455.021 51.4964 453.627 53.0544 452.315 54.6124C453.299 53.5464 454.119 52.6444 454.775 51.9064Z"
            fill="url(#paint2_radial)"
          />
          <path
            id="Path_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M460.515 36.8183L430.667 2.70615C428.289 -0.0818615 423.943 -0.573864 421.155 1.96815L420.007 2.95215C417.218 5.33017 416.726 9.67619 419.269 12.4642L444.443 41.0004L445.017 41.6564C452.479 49.1184 449.937 56.4984 448.051 59.6145C449.527 57.8924 451.003 56.1704 452.397 54.6124C453.709 53.0544 455.103 51.4964 456.415 50.0204C457.727 48.5444 458.957 47.1504 459.777 46.2484C462.647 43.4604 463.057 39.6064 460.515 36.8183Z"
            fill="url(#paint3_linear)"
          />
        </g>
        <g id="Group_2">
          <path
            id="Path_5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M458.875 80.3607L457.727 79.3767C454.939 76.9987 454.447 72.6526 456.989 69.8646L486.837 35.7524C489.215 32.9644 493.561 32.4724 496.349 35.0144L497.497 35.9985C500.285 38.3765 500.777 42.7225 498.235 45.5105L468.387 79.6227C466.009 82.4107 461.827 82.7387 458.875 80.3607Z"
            fill="url(#paint4_linear)"
          />
          <path
            id="Path_6"
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M483.147 41.3284L482.573 40.6724L477.981 45.9204L478.473 46.4944C486.345 54.3665 482.983 62.3205 481.179 65.1085L481.835 64.3705C482.901 63.1405 484.541 61.2545 486.263 59.2045C488.067 56.0885 490.609 48.7084 483.147 41.3284Z"
            fill="url(#paint5_linear)"
          />
          <path
            id="Path_7"
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M492.577 51.9065L493.807 50.5124C493.889 50.3484 494.053 50.1844 494.135 50.0204C492.823 51.4965 491.429 53.0545 490.117 54.6125C491.101 53.5465 492.003 52.6445 492.577 51.9065Z"
            fill="url(#paint6_radial)"
          />
          <path
            id="Path_8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M498.317 36.8184L468.468 2.70621C466.09 -0.0818005 461.744 -0.573803 458.956 1.96821L457.808 2.95222C455.02 5.33023 454.528 9.67625 457.07 12.4643L482.244 41.0004L482.818 41.6564C490.281 49.1185 487.738 56.4985 485.852 59.6145C487.328 57.8925 488.804 56.1705 490.199 54.6125C491.511 53.0545 492.905 51.4965 494.217 50.0205C495.529 48.5445 496.759 47.1505 497.579 46.2484C500.449 43.4604 500.859 39.6064 498.317 36.8184Z"
            fill="url(#paint7_linear)"
          />
        </g>
      </g>
      <g id="Group_3">
        <path
          className="text-liqpay dark:text-liqpay-dark"
          id="Path_9"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.80401 80.0325C0.656004 78.8845 0 77.1625 0 75.0305V7.5441C0 5.33009 0.656003 3.60808 2.05001 2.21407C3.44402 0.820066 5.16603 0.164062 7.38004 0.164062C9.59405 0.164062 11.5621 0.820066 12.8741 2.21407C14.2681 3.60808 14.9241 5.33009 14.9241 7.5441V69.7824H47.1503C51.7423 69.7824 54.1203 71.8325 54.1203 75.8505C54.1203 79.8685 51.7423 81.9185 47.1503 81.9185H6.97004C4.75603 81.9185 3.03402 81.2625 1.80401 80.0325Z"
          fill="currentColor"
        />
        <path
          className="text-liqpay dark:text-liqpay-dark"
          id="Path_10"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.7644 80.5244C64.3704 79.1304 63.7144 77.3264 63.7144 75.0304V7.46204C63.7144 5.24803 64.3704 3.52602 65.7644 2.13201C67.1584 0.738004 68.8804 0.0820007 71.0944 0.0820007C73.3084 0.0820007 75.2764 0.738004 76.5885 2.13201C77.9825 3.52602 78.6385 5.24803 78.6385 7.46204V75.0304C78.6385 77.2444 77.9825 79.1304 76.5885 80.5244C75.1944 81.9184 73.3904 82.5744 71.0944 82.5744C68.9624 82.5744 67.1584 81.9184 65.7644 80.5244Z"
          fill="currentColor"
        />
        <path
          className="text-liqpay dark:text-liqpay-dark"
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M163.919 97.2525C163.919 95.8585 163.427 94.5465 162.607 93.1525L158.507 87.0025C156.129 83.1485 153.259 80.5244 149.733 79.3764C156.539 76.3424 161.787 71.5864 165.395 65.0264C169.085 58.5483 170.889 50.5943 170.889 41.4922C170.889 33.0462 169.331 25.6661 166.215 19.4341C163.099 13.2841 158.671 8.44605 152.849 5.00203C147.109 1.72201 140.221 0 132.431 0C124.477 0 117.671 1.55801 111.848 5.00203C106.108 8.44605 101.598 13.2021 98.4824 19.4341C95.4484 25.7481 93.8084 33.0462 93.8084 41.4922C93.8084 49.8563 95.3664 57.2363 98.4824 63.5503C101.598 69.7004 106.026 74.5384 111.848 77.9824C117.671 81.2624 124.477 82.9845 132.431 82.9845C135.219 82.9845 137.433 83.4765 139.155 84.2965C140.877 85.1165 142.271 86.4285 143.337 88.2325L150.061 99.3845C150.881 100.615 151.947 101.599 153.095 102.255C154.325 102.911 155.637 103.239 157.031 103.239C158.835 103.239 160.475 102.583 161.869 101.517C163.263 100.451 163.919 98.9745 163.919 97.2525ZM156.047 41.3283C156.047 50.8403 153.915 58.2204 149.733 63.3864C145.551 68.5524 139.729 71.0944 132.267 71.0944C124.805 71.0944 118.901 68.5524 114.719 63.3864C110.537 58.2204 108.405 51.0043 108.405 41.3283C108.405 31.6522 110.537 24.4362 114.719 19.2702C118.901 14.1861 124.723 11.6441 132.267 11.6441C139.811 11.6441 145.551 14.1041 149.733 19.2702C153.915 24.4362 156.047 31.6522 156.047 41.3283Z"
          fill="currentColor"
        />
        <path
          className="text-liqpay dark:text-liqpay-dark"
          id="Shape_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M186.879 75.0304C186.879 77.3265 187.535 79.1305 188.929 80.5245C190.159 81.9185 192.045 82.5745 194.259 82.6565C196.555 82.6565 198.359 82.0005 199.753 80.6065C201.147 79.2945 201.803 77.4905 201.803 75.1124V50.3483H222.385C231.077 50.3483 237.801 48.2163 242.639 43.7883C247.477 39.4422 249.937 33.2922 249.937 25.5022C249.937 17.7121 247.477 11.5621 242.639 7.29807C237.801 2.87005 231.077 0.738037 222.385 0.738037H194.095C191.881 0.738037 190.159 1.39404 188.847 2.54205C187.535 3.77205 186.879 5.49406 186.879 7.70808V75.0304ZM235.834 25.6662C235.834 34.5223 230.667 39.0323 220.499 39.0323L201.803 38.9503V12.3001H220.499C230.667 12.3001 235.834 16.8102 235.834 25.6662Z"
          fill="currentColor"
        />
        <path
          className="text-liqpay dark:text-liqpay-dark"
          id="Shape_3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M326.28 80.5244C327.674 79.2124 328.412 77.7364 328.412 76.0144C328.412 74.9484 328.166 74.0464 327.838 72.9804L295.94 4.67403C295.202 3.11602 294.136 1.96801 292.742 1.14801C291.348 0.410002 289.872 0 288.232 0C286.592 0 285.116 0.328002 283.722 1.14801C282.246 1.96801 281.18 3.19802 280.524 4.67403L248.707 72.9804C248.297 73.9644 248.051 75.0304 248.051 76.0144C248.051 77.8184 248.707 79.3764 250.183 80.5244C251.577 81.6724 253.299 82.3284 255.021 82.3284C256.333 82.3284 257.481 82.0004 258.547 81.3444C259.613 80.6884 260.433 79.7044 261.089 78.3104L268.06 62.8943H308.404L315.374 78.3104C315.948 79.6224 316.85 80.6884 317.916 81.3444C318.982 82.0004 320.212 82.3284 321.36 82.3284C323.246 82.3284 324.886 81.6724 326.28 80.5244ZM303.484 51.4143H273.062L288.232 17.3021L303.484 51.4143Z"
          fill="currentColor"
        />
        <path
          className="text-liqpay dark:text-liqpay-dark"
          id="Path_11"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M385.812 0.164001C387.534 0.164001 389.092 0.820005 390.486 2.21401C391.88 3.60802 392.536 5.08403 392.536 7.05204C392.536 8.52805 391.962 10.0861 390.814 11.4801L364.656 43.3782V75.2764C364.656 77.6544 364 79.4584 362.606 80.8524C361.212 82.2465 359.49 82.8205 357.358 82.8205C355.144 82.8205 353.258 82.1645 351.864 80.8524C350.47 79.5404 349.814 77.7364 349.814 75.2764V43.3782L323.82 11.3981C322.672 10.0041 322.098 8.52805 322.098 6.97004C322.098 5.16603 322.754 3.52602 324.148 2.13201C325.542 0.738004 327.182 0.0820007 328.822 0.0820007C330.79 0.0820007 332.348 0.902005 333.742 2.62401L357.276 31.8162L380.728 2.62401C382.122 0.984006 383.844 0.164001 385.812 0.164001Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="430.313"
        y1="91.0077"
        x2="471.737"
        y2="70.9235"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1FADC3" />
        <stop offset="0.7072" stopColor="#36B98F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="444.859"
        y1="58.7495"
        x2="452.602"
        y2="57.622"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#123F06" stopOpacity="0.01" />
        <stop offset="1" stopColor="#123F06" />
      </linearGradient>
      <radialGradient
        id="paint2_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(438.327 56.1695) scale(19.9933 22.8494)"
      >
        <stop offset="0.4185" stopColor="#123F06" stopOpacity="0.01" />
        <stop offset="1" stopColor="#123F06" />
      </radialGradient>
      <linearGradient
        id="paint3_linear"
        x1="401.983"
        y1="45.514"
        x2="452.22"
        y2="62.8745"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9FDB57" />
        <stop offset="1" stopColor="#71CA5E" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="468.161"
        y1="91.0285"
        x2="509.585"
        y2="70.9443"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1FADC3" />
        <stop offset="0.7072" stopColor="#36B98F" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="483.071"
        y1="58.4215"
        x2="490.814"
        y2="57.294"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#123F06" stopOpacity="0.01" />
        <stop offset="1" stopColor="#123F06" />
      </linearGradient>
      <radialGradient
        id="paint6_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(476.163 56.1696) scale(19.9933 22.8494)"
      >
        <stop offset="0.4185" stopColor="#123F06" stopOpacity="0.01" />
        <stop offset="1" stopColor="#123F06" />
      </radialGradient>
      <linearGradient
        id="paint7_linear"
        x1="439.809"
        y1="45.5291"
        x2="490.046"
        y2="62.8896"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9FDB57" />
        <stop offset="1" stopColor="#71CA5E" />
      </linearGradient>
    </defs>
  </svg>
)
